export default __webpack_public_path__ + "static/media/nearshorit-powered-by-MP.6ef82ae2.svg";